import { InternalAxiosRequestConfig } from 'axios';

import { getAccessToken } from '../lib/auth/AuthContext';
import { AxiosClient, type AxiosErrorHandlerMap } from '../lib/axios';

const errorHandlerMap: AxiosErrorHandlerMap = {
  401: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('selected_org');
    window.location.href = '/login';
  },
};

export const clientApi = AxiosClient.build(import.meta.env.VITE_API_URL).withMiddleware({
  errorHandlerMap,
  mutationTimeout: 40000,
  requestTransformer: async (request: InternalAxiosRequestConfig) => {
    const token = getAccessToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    request.headers.set('Content-Type', 'application/json');

    if (request.data instanceof FormData) {
      request.headers.delete('Content-Type');
    }
  },
});

export const publicApi = AxiosClient.build(import.meta.env.VITE_API_URL).withMiddleware({
  errorHandlerMap: {},
  mutationTimeout: 40000,
  requestTransformer: async (request: InternalAxiosRequestConfig) => {
    request.headers.set('Content-Type', 'application/json');
  },
});
